import { Carousel } from 'components/carousels/Carousel'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithChildren } from 'react'

export function NewReleasesContainer({ children }: PropsWithChildren) {
  const { t } = useTranslation()

  return <Carousel title={t('common:new_releases')}>{children}</Carousel>
}
